export const passwordRecovery = {
  Back: 'Volver',
  'In order to recover your password, please provide the email used on your registration':
    'Para recuperar su contraseña, ingrese el correo electrónico que utilizó para registrarse',
  'Password Recovery': 'Recuperación de contraseña',
  Send: 'Enviar',
  "We've sent an email with instructions on how the recover your password Check your inbox":
    'Hemos enviado un correo electrónico con instrucciones para recuperar la contraseña. Revisa tu bandeja de entrada',
};
